/**
 * Removes accelerometer and gyroscope from iframe allow attributes
 * to prevent device permission prompts on sites with embedded content.
 */
export function sanitizeIframeAllowAttributes(html: string): string {
  if (!html || typeof html !== "string") return html;
  return html.replace(/allow="([^"]*)"/gi, (_, attr) => {
    const cleaned = attr
      .replace(/\s*accelerometer\s*;?\s*/gi, "")
      .replace(/\s*gyroscope\s*;?\s*/gi, "")
      .replace(/\s*;\s*;/g, ";")
      .replace(/^;|;\s*$/g, "")
      .trim();
    return cleaned ? `allow="${cleaned}"` : "";
  });
}
